import React, { useState } from 'react';
import { useTranslation } from '../i18n';
import { doc, runTransaction } from 'firebase/firestore';
import { analytics, db } from '../firebaseConfig';
import { getUniqueAchievementLevels } from '../utils/functions';
import closeButton from '../images/close-line-white.svg';
import bookmarkIcon from './../images/bookmark-line.svg';
import { logEvent } from 'firebase/analytics';

const ChangeBookmark = ({ userData, fetchUserData }) => {
  const { t } = useTranslation();
  const [bookmarkModalIsOpen, setBookmarkIsOpen] = useState(false);
  const [updatingBookmarks, setUpdatingBookmarks] = useState(false);
  function openBookmarkModal() {
    setBookmarkIsOpen(true);
  }
  function closeBookmarkModal() {
    setBookmarkIsOpen(false);
  }

  const handleUpdateBookmark = async (bookmark) => {
    if (!userData.uid) {
      console.error('No user id');
      return false;
    }
    setUpdatingBookmarks(true);
    logEvent(analytics, 'account_settings_bookmark', {
      bookmark: bookmark,
    });
    const userRef = doc(db, 'Users', userData.uid);

    try {
      await runTransaction(db, async (transaction) => {
        transaction.update(userRef, {
          bookmark: bookmark,
        });
      });
      fetchUserData(
        userData.email,
        false,
        'handleUpdateBookmark, ChangeBookmark.js',
      );
    } catch (error) {
      console.error('Error changing bookmark: ', error);
    } finally {
      setUpdatingBookmarks(false);
      closeBookmarkModal();
    }
  };

  const uniqueAchievements = getUniqueAchievementLevels(
    userData ? userData.achievements?.achievementsUnlocked : [],
  );

  return [
    <div className="row-item" key="item-row">
      <img height={24} width={24} alt="Change bookmark" src={bookmarkIcon} />
      <div
        className="link"
        onClick={() => openBookmarkModal()}
        onKeyDown={(event) => {
          if (event.key === 'Enter') {
            openBookmarkModal();
          }
        }}
        tabIndex={0}
      >
        {t.changebookmark}
      </div>
      <div className="pt-65 fs-s flex-grow align-right">
        {userData?.bookmark ? t[userData.bookmark] : t.default}
      </div>
    </div>,
    bookmarkModalIsOpen && (
      <div className="overlay" key="overlay">
        <div className="buttons-wrapper">
          <div className="buttons-header">
            <span>{t.changebookmark}</span>
            <button
              className="btn-icon"
              onClick={closeBookmarkModal}
              disabled={updatingBookmarks}
            >
              <img
                className="icon"
                src={closeButton}
                width={24}
                height={24}
                alt="Close icon"
              />
            </button>
          </div>
          <div className="separator"></div>
          <div className="buttons">
            {uniqueAchievements.includes(4) && (
              <button
                className="btn btn-secondary"
                onClick={() => handleUpdateBookmark('platinum')}
                disabled={updatingBookmarks}
              >
                {t.platinum}
              </button>
            )}
            {uniqueAchievements.includes(3) && (
              <button
                className="btn btn-secondary"
                onClick={() => handleUpdateBookmark('gold')}
                disabled={updatingBookmarks}
              >
                {t.gold}
              </button>
            )}
            {uniqueAchievements.includes(2) && (
              <button
                className="btn btn-secondary"
                onClick={() => handleUpdateBookmark('silver')}
                disabled={updatingBookmarks}
              >
                {t.silver}
              </button>
            )}
            {uniqueAchievements.includes(1) && (
              <button
                className="btn btn-secondary"
                onClick={() => handleUpdateBookmark('bronze')}
                disabled={updatingBookmarks}
              >
                {t.bronze}
              </button>
            )}
            <button
              className="btn btn-secondary"
              onClick={() => handleUpdateBookmark('default')}
              disabled={updatingBookmarks}
            >
              {t.default}
            </button>
          </div>
        </div>
      </div>
    ),
  ];
};

export default ChangeBookmark;
